import React from 'react';
import styled from '@emotion/styled';

import { getMonth } from '../helpers/helpers';

const Icon = styled.i`
  font-size: ${props => props.theme.size.small};
  position: relative;

  &::after {
    content: '+';
    font-size: 11px;
    font-weight: 700;
    position: absolute;
    left: 25%;
  }
`;

const Container = styled.div`
  position: absolute;
  right: 0;
  top: 5px;
  display: flex;
  justify-content: flex-end;
`;

const Button = styled.button`
  background-color: transparent;
  border: 0;
  font-size: ${props => props.theme.size.large};
  padding-left: ${props => props.theme.size.small};
  transform: translate(5px, -8px);

  &:hover {
    cursor: pointer;
  }
`;

class AddTimelineEntry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isActive: false };

    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.onClickActivate = this.onClickActivate.bind(this);
    this.addEntry = this.addEntry.bind(this);
    this.deactivate = this.deactivate.bind(this);
  }

  onClickActivate() {
    this.setState({ isActive: true });
    this.timer = setTimeout(this.deactivate, 3000);
  }

  deactivate() {
    this.setState({ isActive: false });
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  addEntry(event) {
    // handle form data
    event.preventDefault();
    const { addTimelineEntry, activity } = this.props;
    const status = event.target.innerHTML;
    const d = new Date();
    const month = getMonth(d.getMonth());
    const date = `${d.getDate()} ${month}`;
    const entry = { date, status };
    addTimelineEntry(entry, activity, this.props.activityIndex);
    this.deactivate();
  }

  render() {
    const StatusContainer = styled.div`
      width: 0;
      flex-wrap: nowrap;
      display: flex;
      overflow: hidden;
      transition: width 0.2s ease-out;

      ${this.state.isActive &&
        `
				width: 100%;
				transition: width 0.5s ease-out;
			`}
    `;

    const AddButton = styled.button`
      background-color: ${props => props.theme.colors.dark};
      border: 0;
      border-radius: 5px;
      color: ${props => props.theme.colors.light};
      font-size: ${props => props.theme.size.medium};
      text-transform: uppercase;
      transition: opacity 0.2s ease;
      padding: ${props => props.theme.size.xsmall} ${props => props.theme.size.large};

      &:hover {
        cursor: pointer;
      }

      ${this.state.isActive && 'opacity: 0;'}
    `;

    return (
      <Container>
        <AddButton onClick={this.onClickActivate} aria-label="Add">
          <Icon className="material-icons">
            calendar_today
          </Icon>{' '}
          Add
        </AddButton>
        <StatusContainer>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="fatal">☠️</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="nope">☹️</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="I don't get it">🤨</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="oops mistake">😬</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="shrug">🤷</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="ah there you go!">🙂</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="yeah!">😃</span>
          </Button>
          <Button onClick={this.addEntry}>
            <span role="img" aria-label="wohooo">🎉</span>
          </Button>
        </StatusContainer>
      </Container>
    );
  }
}

export default AddTimelineEntry;
